* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  overflow: visible;
  height: 100%;
}

.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  &.is-error {
    #rule-sets-selector {
      display: none;
    }

    #rule-sets-grid {
      display: none;
    }
  }
}

#rule-sets-grid {
  width: 612px;
  height: 400px;
}
